import { render, staticRenderFns } from "./Sections.vue?vue&type=template&id=328825f6"
import script from "./Sections.vue?vue&type=script&setup=true&lang=ts"
export * from "./Sections.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.26.0__cache-loader@4.1.0_webpack@4_duly6tfyc62fvcli236pnhbyri/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./Sections.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IxTdRecursiveSection: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/td/recursiveSection.vue').default,IxDataTableTaxonomy: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/data-table/Taxonomy.vue').default,IxSearchText: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/SearchText.vue').default,IxDialogSection: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/dialog/section.vue').default,IxDialogDeleteSection: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/dialog/DeleteSection.vue').default,IxDataTable: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/DataTable.vue').default})
